module.exports = "/_next/static/images/sandy-6b069a3153739ed139a6b32050de4847.jpg";